import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=02347f9d&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=02347f9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02347f9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02347f9d')) {
      api.createRecord('02347f9d', component.options)
    } else {
      api.reload('02347f9d', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=02347f9d&scoped=true&", function () {
      api.rerender('02347f9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27a8OrIval0uW/JS/comp/GuestBox.vue"
export default component.exports